import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link, useLocation } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import EnquiryNow from "../common/EnquiryNow";
import Allinone from "../common/Allinone.js";
import Brochure from "../../Images/Brochure/ISBM_PROSPECTUS.pdf";
import { Row, Col, Modal } from "react-bootstrap";

const SchoolDetails = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [show, setShow] = useState(false);

  const { schoolName } = useParams();
  const location = useLocation();

  const [courses, setCourses] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const handleClose = () => setShow(false);

  // Scroll top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Fetch courses
  useEffect(() => {
    if (!schoolName) return;

    axios
      .get(
        `https://isbmuniversity.edu.in/admin-portal/coursesList/${schoolName}`,
      )
      .then((res) => setCourses(res.data?.data || []))
      .catch((err) => console.error("Course error:", err));
  }, [schoolName]);

  // Fetch school details
  useEffect(() => {
    if (!schoolName) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/schools/${schoolName}`,
        );

        setSchoolDetails(res.data?.data?.[0] || null);
      } catch (err) {
        setError("Error fetching school details");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [schoolName]);

  // SEO + Schema
  useEffect(() => {
    if (!schoolDetails) return;

    document.title = schoolDetails.metatitle || "ISBM University";

    const setMeta = (selector, attr, content, isProp = false) => {
      let tag = document.querySelector(selector);

      if (!tag) {
        tag = document.createElement("meta");
        if (isProp) tag.setAttribute("property", attr);
        else tag.setAttribute("name", attr);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content || "");
    };

    // Basic SEO
    setMeta('meta[name="description"]', "description", schoolDetails.metadesc);
    setMeta('meta[name="robots"]', "robots", "index, follow");

    // Open Graph
    setMeta(
      'meta[property="og:title"]',
      "og:title",
      schoolDetails.metatitle,
      true,
    );
    setMeta(
      'meta[property="og:description"]',
      "og:description",
      schoolDetails.metadesc,
      true,
    );
    setMeta(
      'meta[property="og:url"]',
      "og:url",
      `https://isbmuniversity.edu.in/school-details/${schoolDetails.name}`,
      true,
    );

    setMeta(
      'meta[property="og:image"]',
      "og:image",
      "https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp",
      true,
    );

    // Twitter (FIXED)
    setMeta(
      'meta[name="twitter:title"]',
      "twitter:title",
      schoolDetails.metatitle,
    );
    setMeta(
      'meta[name="twitter:description"]',
      "twitter:description",
      schoolDetails.metadesc,
    );
    setMeta(
      'meta[name="twitter:image:src"]',
      "twitter:image:src",
      "https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp",
    );

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }

    canonical.href = `https://isbmuniversity.edu.in/school-details/${schoolDetails.name}`;

    // Schema
    const oldSchema = document.getElementById("school-schema");
    if (oldSchema) oldSchema.remove();

    if (schoolDetails.schema) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "school-schema";

      try {
        const cleaned = schoolDetails.schema
          .replace(/<script[^>]*>/gi, "")
          .replace(/<\/script>/gi, "");

        script.text = cleaned;
        document.head.appendChild(script);
      } catch (e) {
        console.warn("Schema error", e);
      }
    }

    return () => {
      const schema = document.getElementById("school-schema");
      if (schema) schema.remove();
    };
  }, [schoolDetails]);

  // Loading / error states
  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!schoolDetails) return <div>No school details found</div>;

  return (
    schoolDetails && (
      <React.Fragment>
        <title>{schoolDetails.metatitle}</title>
        <meta name="description" content={schoolDetails.metadesc} />
        <meta
          name="SearchEngines"
          content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
                DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
        />
        <meta name="Robots" content="INDEX, FOLLOW" />
        <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
        <meta name="Robots" content="INDEX,ALL" />
        <meta name="YahooSeeker" content="INDEX, FOLLOW" />
        <meta name="msnbot" content="INDEX, FOLLOW" />
        <meta name="googlebot" content="Default, follow" />
        <meta name="owner" content="isbmuniversity.edu.in/" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="2 days" />
        <meta property="og:title" content={schoolDetails.metatitle} />
        <meta property="og:description" content={schoolDetails.metadesc} />
        <meta
          property="og:url"
          content={`https://isbmuniversity.edu.in/school-details/${schoolDetails.name}`}
        />
        <meta
          property="og:image"
          content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
        />
        <meta property="og:image:alt" content="ISBM University" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="ISBM University" />
        <meta name="twitter:title" content={schoolDetails.metatitle} />
        <meta name="twitter:description" content={schoolDetails.metadesc} />
        <meta
          name="twitter:image:src"
          content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@ISBMUniversity" />
        <meta name="twitter:creator" content="@ISBMUniversity" />
        <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
        <meta property="twitter:account_id" content="758619542734053376" />
        <div
          className="d-none"
          dangerouslySetInnerHTML={{
            __html: schoolDetails.schema,
          }}
        ></div>
        <Topnav />
        <div
          className={`innerbackimage position-relative section-hero-banner ${schoolDetails.banner}`}
          aria-label="Best University in Chhattisgarh"
        >
          <div class="bannerShape">
            <div class="bannerDetails" id="bannerDetails">
              <h1 class="text-white mb-3">{schoolDetails.title}</h1>
              <div
                class="mb-3 small text-white"
                dangerouslySetInnerHTML={{
                  __html: schoolDetails.banner_description,
                }}
              ></div>

              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-apply me-2"
                  onClick={() => setModalShow(true)}
                >
                  Apply Now
                </button>
                <EnquiryNow
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
                <a
                  onClick={(e) => {
                    e.preventDefault(); // stop auto-download
                    setModalShow(true); // open modal instead
                  }}
                  className="btn btn-download"
                  href={Brochure} // keep reference
                  target="_blank"
                  download="ISBM_PROSPECTUS.pdf"
                >
                  Download Brochure
                </a>
              </div>
            </div>
          </div>
        </div>

        <section className="ptb-50 text-center">
          <div className="container-xxl">
            <div className="text-center mb-5">
              <h2 className="text-blue section-title modern-title">Overview</h2>
            </div>
            <div
              class="overview"
              dangerouslySetInnerHTML={{
                __html: schoolDetails.description,
              }}
            ></div>
          </div>
        </section>

        <section class="py-5 bg-purple text-white text-center">
          <h2>Transform Your Tomorrow</h2>
          <p class="w-50 m-auto text-center my-4">
            Unlock endless possibilities and shape your future today. Transform
            your tomorrow with the education that empowers you to achieve
            greatness.
          </p>
          <button
            type="button"
            class="btn btn-sm btn-download px-5 me-2"
            onClick={() => setModalShow2(true)}
          >
            Apply Now
          </button>
          <EnquiryNow show={modalShow2} onHide={() => setModalShow2(false)} />
        </section>

        <section className="ptb-50 color-section">
          <div className="container-xxl">
            <div className="text-center mb-5">
              <h2 className="text-blue section-title modern-title">
                School Outcomes
              </h2>
            </div>
            <div
              class="overview"
              dangerouslySetInnerHTML={{
                __html: schoolDetails.outcome,
              }}
            ></div>
          </div>
        </section>

        <section className="ptb-50">
          <div className="container-xxl">
            <Row>
              <Col lg={12}>
                <div className="text-center mb-5">
                  <h2 className="text-blue section-title modern-title">
                    Discover Our Courses
                  </h2>
                  <p className="lead">In-demand courses across industries</p>
                </div>

                {(() => {
                  const courseOrder = [
                    "Doctorate",
                    "Post Graduate Diploma",
                    "Postgraduate",
                    "Undergraduate",
                    "Diploma",
                    "Certificate",
                  ];

                  const sortedCourses = [...courses].sort((a, b) => {
                    const indexA = courseOrder.indexOf(a.level);
                    const indexB = courseOrder.indexOf(b.level);

                    return (
                      (indexA === -1 ? 999 : indexA) -
                      (indexB === -1 ? 999 : indexB)
                    );
                  });

                  return (
                    <div className="row row-cols-1 row-cols-md-3 g-4">
                      {sortedCourses.map((course) => (
                        <div key={course.id} className="col p-2">
                          <div className="card rounded-3 courseBox p-0 h-100 shadow-lg bg-body border-0">
                            <div className="card-header">
                              <Link
                                to={`/course-details/${course.name}`}
                                target="_blank"
                                className="text-decoration-none"
                              >
                                <h3 className="card-title font-weight-bold m-0">
                                  {course.title}
                                </h3>
                              </Link>
                            </div>

                            <div className="card-body d-flex flex-column">
                              <div className="col">
                                <Row className="info-line">
                                  <i className="ti ti-file-spark me-2 align-self-center"></i>
                                  <p>{course.level}</p>
                                </Row>

                                <Row className="info-line">
                                  <i className="ti ti-file-report me-2 align-self-center"></i>
                                  <p>{course.duration}</p>
                                </Row>

                                <Row className="info-line">
                                  <i className="ti ti-file-text-shield me-2 align-self-center col-auto"></i>
                                  <p className="col-10">{course.eligibility}</p>
                                </Row>
                              </div>

                              <div className="d-flex flex-wrap mt-auto">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-apply mt-md-2 mt-0 me-2"
                                  onClick={() => setModalShow(true)}
                                >
                                  Apply Now
                                </button>

                                <Link
                                  className="btn btn-sm btn-apply mt-md-2 mt-0"
                                  to={`/course-details/${course.name}`}
                                  target="_blank"
                                >
                                  <span className="gdlr-core-content">
                                    View Details
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </Col>
            </Row>
          </div>
        </section>
        <Allinone />
        <Footer />
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="video_schools_abcdsa"
        >
          <Modal.Body className="p-0 bg-transparent">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/jgS_lbVI428"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    )
  );
};

export default SchoolDetails;
